
import SubtleBadge from '../../../../components/common/SubtleBadge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ReactNode } from 'react';
// نمایش وضعیت massive در تاریخچه
type MassiveStatusRendererProps = {
  status?: number | null;
  processingLabel?: ReactNode;
};

const MassiveStatusRenderer = ({
  status,
  processingLabel = 'درحال جستجو'
}: MassiveStatusRendererProps) => {
  const statusEl = () => {
    switch (status) {
      case 6:
        return (
          <SubtleBadge pill bg="success" className="d-block fs--2">
            <FontAwesomeIcon
              icon="check"
              transform="shrink-2"
              className="mx-1"
            />
            پایان (موفق)
          </SubtleBadge>
        );

      case 2:
        return (
          <SubtleBadge pill bg="info" className="d-block  fs--2">
            <FontAwesomeIcon
              icon="stream"
              transform="shrink-2"
              className="mx-1"
            />
            در صف جستجو
          </SubtleBadge>
        );
      case 4:
        return (
          <SubtleBadge pill bg="info" className="d-block  fs--2">
            <FontAwesomeIcon
              icon="stream"
              transform="shrink-2"
              className="mx-1"
            />
            {processingLabel}
          </SubtleBadge>
        );
      case 3:
        return (
          <SubtleBadge pill bg="danger" className="d-block fs--2">
            <FontAwesomeIcon icon="ban" transform="shrink-2" />
            خطا
            <FontAwesomeIcon className="mx-1" icon="exclamation-circle" />
          </SubtleBadge>
        );
      case 49:
        return (
          <SubtleBadge pill bg="warning" className="d-block  fs--2">
            <FontAwesomeIcon
              icon="pause"
              transform="shrink-2"
              className="mx-1"
            />
            متوقف شده
          </SubtleBadge>
        );

      default:
        return <></>;
    }
  };
  return (
    <div className="w-100 d-flex h-100 align-items-center justify-content-center ">
      {statusEl()}
    </div>
  );
};

export default MassiveStatusRenderer;
